import moment from "moment";
import React, { Component } from "react";
import FinanceServices from "../../services/axiosServices/apiServices/FinanceServices";
import SwalServices from "../../services/swalServices/SwalServices";
import { saveAs } from "file-saver";
import PageLoader from "../../components/common/pageLoader/PageLoader";
import { isValidForm, validate } from "../../utils/validation/CommonValidator";
import { CommonValidationMessages } from "../../utils/Messages";
import ValidationText from "../../utils/validation/ValidationText";
import Table from "../../components/table/Table";
import ActionContainer from "../../components/UIComponent/ActionTableComponent/actionContainer";
import DropdownAction from "../../components/dropdown/DropdownAction";

export default class DeferredIncomeReport extends Component {
    constructor(props) {
        super(props);
        this.FinanceServices = new FinanceServices();
        this.swalServices = new SwalServices();
        this.state = {
            options: [],
            startDate: "",
            endDate: "",
            pagination: {
                pageNo: 1,
                pageSize: 10,
                orderByColumn: "CreatedAt",
                orderFlag: 0,
                searchText: "",


            },
            validationRule: {
                startDate: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace("{0}", "Start date for Deferred Income Report"),
                    },
                ],
                endDate: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace("{0}", "End date for Deferred Income Report"),
                    },
                    {
                        type: "minEndDate",
                        minEndDate: "startDate",
                        message: CommonValidationMessages.SelectRequired.replace("{0}", "greater end date")
                    }
                ],

            },
            validState: {
                isValid: true,
                error: {},
            },
            deferredIncomeReportList: [],
            isLoading: false,
            totalCount: 0,
            totalResultes: 0,
            previousReportFor: "",
            previousReportStartDate: "",
            previousReportEndDate: "",
            isLoading: false,
            actionDropdownPaid: ["Download"],

        };

    }

    componentDidMount = () => {
        this.getAllDeferredIncomeReportList();
    }

    setPagination = (newPagination) => {
        this.setState(
            { pagination: newPagination },
            () => this.getAllDeferredIncomeReportList()
        );
    };
    actions = (element, index, value) => {

        return element !== "deferredIncomeReportId" ? null : (

            <div className="relative w-full credit-note-action-dropdown">

                <ActionContainer>

                    <div className="mr-8">

                        <DropdownAction
                            key={index}
                            value={value}
                            id={index}
                            index={index}
                            options={this.state.actionDropdownPaid}
                            align="right"
                            onOptionClick={this.actionClick.bind(this)}
                        />

                    </div>

                </ActionContainer>

            </div>
        );
    };


    getAllDeferredIncomeReportList = () => {

        this.setState({ isLoading: true });
        let pagination = { ...this.state.pagination };
        this.FinanceServices.getAllDeferredIncomeReportList(pagination).then((response) => {
            if (response.statusCode === 200 && response.responseItem != null) {
                let details = response.responseItem.responseContent.itemList.map((item) => ({
                    ...item,
                    deferredIncomeReportGeneratedDate: item.deferredIncomeReportGeneratedDate
                        ? moment(item.deferredIncomeReportGeneratedDate).format("DD MMM YYYY")
                        : "",
                    deferredIncomeReportStartDate: item.deferredIncomeReportStartDate
                        ? moment(item.deferredIncomeReportStartDate).format("DD MMM YYYY")
                        : "",
                    deferredIncomeReportEndDate: item.deferredIncomeReportEndDate
                        ? moment(item.deferredIncomeReportEndDate).format("DD MMM YYYY")
                        : "",
                }));
                this.setState({
                    deferredIncomeReportList: details,
                    totalCount: response.responseItem.responseContent.totalCount,
                })
            }
            else {
                this.swalServices.Error(response.message);
            }
            this.setState({ isLoading: false });
        });
    }


    actionClick = (index, value, option, event) => {
        if (option === "Download") {
            if (value && value > 0) {
                let deferredIncomeReportId = this.state.deferredIncomeReportList[index].deferredIncomeReportId;

                let deferredIncomeReportStartDate = this.state.deferredIncomeReportList[index].deferredIncomeReportGeneratedDate;

                this.downloadSheetByDeferredIncomeReportId(deferredIncomeReportId, deferredIncomeReportStartDate)
            }
        }
    };

    downloadSheetByDeferredIncomeReportId = (deferredIncomeReportId, deferredIncomeReportStartDate) => {

        this.setState({ isLoading: true });
        let request = [];
        request.push(deferredIncomeReportId);
        this.FinanceServices.downloadSheetByDeferredIncomeReportId(request).then((response) => {
            if (response.status === 200 && response.data != null) {
                const formatter = new Intl.DateTimeFormat('en-GB', { month: 'long' });
                const month = formatter.format(new Date(deferredIncomeReportStartDate));
                const year = new Date(deferredIncomeReportStartDate).getFullYear();
                let blob = new Blob([response.data])
                saveAs(blob, `DeferredIncome_${month}_${year}.xlsx`);

            }
            else {
                this.swalServices.Error(response.message);
            }
            this.setState({ isLoading: false });
        });
    }
    handleChange = (e) => {
        const { name, value } = e.target;

        this.setState({
            [name]: value
        });
    };
    validateField = (key) => {
        const validationData = {
            ...this.state.pagination,
            startDate: this.state.startDate,
            endDate: this.state.endDate
        };
    
        const newValidState = validate(
            key,
            validationData,
            this.state.validationRule,
            this.state.validState
        );
    
        this.setState({ validState: newValidState });
    };
    isValidateAllFields = () => {
        const validationData = {
            ...this.state.pagination,
            startDate: this.state.startDate,
            endDate: this.state.endDate
        };
    
        const newValidState = isValidForm(
            validationData,
            this.state.validationRule,
            this.state.validState
        );
    
        this.setState({ validState: newValidState });
    
        return newValidState.isValid;
    };

    generateDeferredIncomeReport = () => {

        if (!this.isValidateAllFields()) {
            return;
        }

        const { startDate, endDate } = this.state;

        if (!startDate || !endDate) {
            this.swalServices.Alert(
                "Please select start date and end date for deferred income report"
            );
            return;
        }

        this.setState({ isLoading: true });

        let request = {
            startDate: moment(startDate).format("DD MMM YYYY"),
            endDate: moment(endDate).format("DD MMM YYYY")
        };

        this.FinanceServices.generateDeferredIncomeReport(request).then((response) => {

            if (response.statusCode === 200 && response.responseItem != null) {

                this.swalServices.Success(
                    "Deferred income record generated successfully."
                );

                this.getAllDeferredIncomeReportList();

                this.setState({
                    pagination: { ...this.state.pagination, },
                    startDate: "",
                    endDate: "",
                    validState: {
                        isValid: true,
                        error: {}
                    }
                });

            }
            else if (response.statusCode === 409) {

                this.swalServices.Error(response.message);

                this.setState({
                    pagination: {
                        ...this.state.pagination,
                    },
                    startDate: "",
                    endDate: ""
                });

            }
            else {
                this.swalServices.Error(response.message);
            }

            this.setState({ isLoading: false });

        }).catch((error) => {

            this.setState({ isLoading: false });

            this.swalServices.Error(
                "Something went wrong while generating deferred income report."
            );
        });
    };

    render() {
        return (
            <div className="main-body-section finance-body-sec">
                <div className="bg-white">
                    <div className="grid grid-cols-12 gap-6 w-full px-8 py-10">
                        {/* <div className="col-span-3">
                            <label
                                className="input-title mb-3"
                                htmlFor="default"
                            >
                                Date<span className="text-[#C00000]">*</span>
                            </label>
                            <div className="">
                                <input
                                    id="currentDate"
                                    name="currentDate"
                                    className="date-pickers form-input rounded-none w-full shadow-red py-3 text-lg"
                                    type="date"
                                    value={moment(this.state.currentDate).format("yyyy-MM-DD")}
                                    onChange={(event) => this.setState({ currentDate: event.target.value })}

                                />
                            </div>
                        </div> */}

                        <div className="col-span-3">
                            <label
                                className="input-title mb-3"
                                for="default"
                            >
                                Start Date<span className="text-[#C00000]">*</span>
                            </label>
                            <div className="">
                                <input
                                    id="startDate"
                                    name="startDate"
                                    className="date-pickers form-input rounded-none w-full shadow-red py-3 text-lg"
                                    type="date"
                                    value={
                                        this.state.startDate
                                            ? moment(this.state.startDate).format("YYYY-MM-DD")
                                            : ""
                                    }
                                    onChange={this.handleChange}
                                    onBlur={() => this.validateField("startDate")}
                                />
                            </div>
                            {/* <ValidationText error={this.state.validState.error.startDate} /> */}
                        </div>

                        <div className="col-span-3">
                            <label
                                className="input-title mb-3"
                                for="default"
                            >
                                End Date<span className="text-[#C00000]">*</span>
                            </label>
                            <div className="">
                                <input
                                    id="endDate"
                                    name="endDate"
                                    className="date-pickers form-input rounded-none w-full shadow-red py-3 text-lg"
                                    type="date"
                                    value={
                                        this.state.endDate
                                            ? moment(this.state.endDate).format("YYYY-MM-DD")
                                            : ""
                                    }
                                    onChange={this.handleChange}
                                    onBlur={() => this.validateField("endDate")}
                                />
                            </div>
                            {/* <ValidationText error={this.state.validState.error.endDate} /> */}
                        </div>
                        <div className="col-span-4">
                            <button className="btn btn-blue text-xl border text-white mt-8"
                                onClick={() => this.generateDeferredIncomeReport()}
                            >
                                Generate Deferred Income Report
                            </button>
                        </div>



                    </div>
                    <div className="grid grid-cols-12 gap-6 w-full items-center justify-center px-8 py-10">
                        <div className="2xl:col-span-12 lg:col-span-12 col-span-12 w-full">
                            {this.state.isLoading ?
                                <PageLoader /> :
                                <Table
                                    columns={[
                                        { name: "deferredIncomeReportGeneratedDate", title: "Generate Date", },
                                        { name: "deferredIncomeReportStartDate", title: "Start Date" },
                                        { name: "deferredIncomeReportEndDate", title: "End Date" },
                                        { name: "deferredIncomeReportId", title: " Action" },

                                    ]}
                                    pagination={this.state.pagination}
                                    rows={this.state.deferredIncomeReportList}
                                    sortingColumns={[""]}
                                    isLoading={this.state.isLoading}
                                    totalResultes={this.state.totalResultes}
                                    totalCount={this.state.totalCount}
                                    setPagination={this.setPagination.bind(this)}
                                    customScope={[
                                        {
                                            column: "deferredIncomeReportId",
                                            renderTableData: this.actions.bind(this),
                                        },
                                        // {
                                        //     column: "selectRow",
                                        //     renderTableData: this.select.bind(this),
                                        //     valueColumnName: "financeAdhocInvoiceId",
                                        // },
                                    ]}
                                />

                            }
                        </div>
                    </div>
                </div>
            </div >
        );
    }
}
